"use client";

import { usePathname } from 'next/navigation';
import CitySelector from "@components/organisms/CitySelector";
import VerticalDivider from "@components/atoms/VerticalDivider";

interface MobileCitySelectionHandlerProps {
  showIcon?: boolean;
}

export default function MobileCitySelectionHandler({ 
  showIcon = true
}: MobileCitySelectionHandlerProps) {
  const pathname = usePathname();

  // Routes where city selector should be hidden
  const hideCitySelectorRoutes = [
    '/quote/',
    '/cars/deal-confirmation/',
    '/payment-success/'
  ];
  
  const shouldHideCitySelector = hideCitySelectorRoutes.some(route => 
    pathname.startsWith(route) || pathname === route.slice(0, -1)
  );

  if (shouldHideCitySelector) {
    return null;
  }

  return (
    <>
      <VerticalDivider />
      <CitySelector showIcon={showIcon} />
    </>
  );
} 